import {
  type ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { errorInterceptor } from './core/interceptors/error-interceptor';
import { offlineInterceptor } from './core/interceptors/offline-interceptor';
import { tokenInterceptor } from './core/interceptors/token-interceptor';
import { provideOfflineServiceWorker } from './core/service-worker/service-worker';
import { OverlayCoordinatorService } from './services/overlay-coordinator/overlay-coordinator';
import { CustomFontsService } from './services/readium/settings/custom-fonts';
import { TranslationService } from './services/translation/translation';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(
      withFetch(),
      withInterceptors([offlineInterceptor, tokenInterceptor, errorInterceptor]),
    ),
    provideOfflineServiceWorker(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/nubereader/resources/locales/',
      }),
    }),
    provideAppInitializer(() => {
      inject(TranslationService);
      inject(CustomFontsService);
      inject(OverlayCoordinatorService);
    }),
  ],
};
